import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { computePartCount } from "../../../seoAnalyzer/planHelper";

export default function OutlineCard({ analysis, content }) {
  const { t } = useTranslation();
  const [showOutline, setShowOutline] = useState(false);
  // Part Count Calculation
  const partCounts = useMemo(() => {
    return analysis !== undefined && content !== undefined
      ? computePartCount(
          Object.keys(analysis.outline.nb_hn)
            .filter((key) => analysis.outline.nb_hn[key] > 0)
            .map((key) => {
              return { [key]: analysis.outline.nb_hn[key] };
            }),
          analysis.outline.nb_hn.h2,
          analysis.outline.nb_hn.h3,
          analysis.outline.nb_hn.h4,
          analysis.content.nb_words,
          content.outline.html
        )
      : 0;
  }, [analysis]);

  // Total Number of Hn Tags
  const hnSum = useMemo(() => {
    return analysis !== undefined && content !== undefined
      ? Object.keys(analysis.outline.nb_hn)
          .map((key) => {
            return { [key]: analysis.outline.nb_hn[key] };
          })
          .reduce((sum, curr) => sum + Object.values(curr)[0], 0)
      : 0;
  }, [analysis]);

  // Show/Hide Outline
  const toggleOutline = () => {
    setShowOutline(!showOutline);
  };

  return analysis !== undefined && content !== undefined ? (
    <>
      <div className="py-3 break-words">
        {/* Heading Well Organized */}
        <div className="text-xs   text-black">
          <span>
            {t("Headings-well-organized", "Headings well-organized")}?
            <span
              className={`${
                analysis.outline.organized_headings && hnSum > 0
                  ? "text-green-500"
                  : analysis.outline.organized_headings == false && hnSum > 0
                  ? "text-red-600"
                  : "text-gray_local-400"
              }`}
            >
              {" "}
              {`${
                analysis.outline.organized_headings && hnSum > 0
                  ? t("Yes", "Yes")
                  : analysis.outline.organized_headings == false && hnSum > 0
                  ? t("No", "No")
                  : t("no-heading", "No headings")
              }`}
            </span>
          </span>
        </div>

        {/* Well Sized Headings */}
        <div className="text-xs   text-black">
          <span>
            {" "}
            {t("Well-sized-headings", "Well-sized headings")}:
            <span
              className={`${
                100 - analysis?.outline.well_sized_headings > 90 && hnSum > 0
                  ? "text-green-500"
                  : 100 - analysis?.outline.well_sized_headings > 80 &&
                    hnSum > 0
                  ? "text-yellow-500"
                  : hnSum > 0
                  ? "text-red-600"
                  : "text-gray_local-400"
              }`}
            >
              {" "}
              {`${
                hnSum > 0
                  ? `${(100 - analysis?.outline.well_sized_headings).toFixed(
                      2
                    )}%`
                  : t("no-heading", "No headings")
              }`}
            </span>
          </span>
        </div>

        {/* Good Section Depth */}
        <div className="text-xs   text-black">
          <span>
            {" "}
            {t("Good-section-depth", "Good section depth")}?
            <span
              className={`${
                analysis.outline.good_section_depth && hnSum > 0
                  ? "text-green-500"
                  : analysis.outline.good_section_depth == false && hnSum > 0
                  ? "text-red-600"
                  : "text-gray_local-400"
              }`}
            >
              {" "}
              {`${
                analysis.outline.good_section_depth && hnSum > 0
                  ? t("Yes", "Yes")
                  : analysis.outline.good_section_depth == false && hnSum > 0
                  ? t("No", "No")
                  : t("no-heading", "No headings")
              }`}
            </span>
          </span>
        </div>

        {/* Repeated Headings */}
        <div className="text-xs   text-black">
          <span>
            {t("Repeated-headings", "Repeated headings")}?
            <span
              className={`${
                analysis.outline.repeated_headings == false && hnSum > 0
                  ? "text-green-500"
                  : analysis.outline.repeated_headings == true && hnSum > 0
                  ? "text-red-600"
                  : "text-gray_local-400"
              }`}
            >
              {" "}
              {`${
                analysis.outline.repeated_headings && hnSum > 0
                  ? t("Yes", "Yes")
                  : analysis.outline.repeated_headings == false && hnSum > 0
                  ? t("No", "No")
                  : t("no-heading", "No headings")
              }`}
            </span>
          </span>
        </div>

        {/* Hn Tag Count */}
        <div className="text-xs text-black">
          <span>
            {" "}
            {t(
              "SEO-ANALYSIS-Number-of-heading-tagCount",
              "Nombre de balises Hn"
            )}
            :
            <span
              className={`${
                partCounts >= 100 && hnSum > 0
                  ? "text-green-500"
                  : partCounts > 35 && hnSum > 0
                  ? "text-yellow-500"
                  : hnSum > 0
                  ? "text-red-600"
                  : "text-gray_local-400"
              }`}
            >
              {" "}
              {`
                        ${
                          hnSum === 0
                            ? t("no-heading", "No headings")
                            : ` ${hnSum} Hn
                    ${`${
                      hnSum > 0
                        ? ` ( ${Object.entries(analysis.outline.nb_hn)
                            .filter(([key, value]) => value > 0)
                            .map(
                              ([key, value]) =>
                                `${value} ${t(
                                  "SEO-ANALYSIS-" + key.toUpperCase(),
                                  key.toUpperCase()
                                )}`
                            )
                            .join(", ")
                            .replace(
                              /,([^,]*)$/,
                              t("SEO-ANALYSIS-and", " et") + "$1"
                            )})`
                        : ""
                    }`}`
                        }
            
                    `}{" "}
            </span>
          </span>
        </div>

        {/* Handle Show/Hide Outline */}

        {showOutline && content?.outline.html.trim() && (
          <div className="mt-4 max-h-52 overflow-y-auto  ">
            <div
              className="w-full text-black text-xs mt-3 pb-3 break-words"
              dangerouslySetInnerHTML={{
                __html: content?.outline.preview
                  ?.replace(/</g, "&lt;")
                  ?.replace(/>/g, "&gt;")
                  ?.replace(/ /g, "&nbsp;")
                  ?.replace(/\n/g, "<br>"),
              }}
            ></div>
          </div>
        )}
        <div className="flex justify-center mt-3">
          <button
            className="text-sm hover:bg-blue-100  bg-blue-200 text-white disabled:bg-slate-200 disabled:text-slate-400 font-light px-5 py-[6px] rounded-lg flex items-center"
            onClick={toggleOutline}
            disabled={content?.outline.preview.trim().length === 0}
          >
            {showOutline
              ? t("hide-the-plan", "Hide the plan")
              : t("view-the-plan", "View the plan")}
          </button>
        </div>
      </div>
    </>
  ) : null;
}
